<template>
    <v-radio-group
        class="fill-width"
        inline
    >
        <v-radio
            label="Male"
            value="M"
        ></v-radio>
        <v-radio
            label="Female"
            value="F"
        ></v-radio>
        <v-radio
            label="No Answer"
            :value="null"
        ></v-radio>
    </v-radio-group>
</template>

<script lang="ts" setup></script>
